export const SECTEURS = [
  ['batiment', '🏗️', 'Bâtiment / BTP', 'Chantiers, devis, équipe & paie suisse'],
  ['magasin', '🛒', 'Magasin / Commerce', 'Stock, ventes, remises clients'],
  ['mixte', '🔗', 'Mix — les deux', 'Bâtiment + magasin connectés'],
];

export const METIERS = [
  [
    'carrelage',
    '🧱',
    'Carrelage / Bâtiment',
    ['Matériaux', 'Sous-traitance', 'Location', 'Carburant', 'Divers'],
    ['m²', 'ml', 'forfait', 'h', 'pce'],
  ],
  [
    'electricien',
    '⚡',
    'Électricien',
    ['Matériel élec.', 'Sous-traitance', 'Location', 'Carburant', 'Divers'],
    ['pce', 'ml', 'h', 'forfait'],
  ],
  [
    'plombier',
    '🔧',
    'Plombier / Chauffage',
    ['Fournitures', 'Sous-traitance', 'Location', 'Carburant', 'Divers'],
    ['pce', 'ml', 'h', 'forfait'],
  ],
  [
    'peintre',
    '🎨',
    'Peintre / Plâtrier',
    ['Peinture', 'Matériaux', 'Location', 'Carburant', 'Divers'],
    ['m²', 'h', 'forfait', 'pce'],
  ],
  [
    'menuisier',
    '🪚',
    'Menuisier / Charpentier',
    ['Bois & matériaux', 'Sous-traitance', 'Location', 'Carburant', 'Divers'],
    ['m²', 'ml', 'pce', 'h', 'forfait'],
  ],
  [
    'macon',
    '🧰',
    'Maçon / Gros œuvre',
    ['Matériaux', 'Sous-traitance', 'Location', 'Carburant', 'Divers'],
    ['m³', 'm²', 'ml', 'h', 'forfait'],
  ],
  [
    'paysagiste',
    '🌳',
    'Jardinier / Paysagiste',
    ['Végétaux', 'Matériaux', 'Location', 'Carburant', 'Divers'],
    ['m²', 'h', 'forfait', 'pce'],
  ],
  [
    'serrurier',
    '🔩',
    'Serrurier / Métallier',
    ['Métaux', 'Fournitures', 'Sous-traitance', 'Carburant', 'Divers'],
    ['pce', 'ml', 'h', 'forfait'],
  ],
  [
    'garage',
    '🚗',
    'Garage / Auto',
    ['Pièces', 'Pneus', 'Sous-traitance', 'Fournitures', 'Divers'],
    ['pce', 'h', 'forfait'],
  ],
  [
    'nettoyage',
    '🧽',
    'Nettoyage / Conciergerie',
    ['Produits', 'Matériel', 'Sous-traitance', 'Carburant', 'Divers'],
    ['h', 'm²', 'forfait', 'pce'],
  ],
  [
    'coiffure',
    '💇',
    'Coiffure / Esthétique',
    ['Produits', 'Matériel', 'Loyer', 'Divers'],
    ['prestation', 'pce', 'forfait'],
  ],
  [
    'resto',
    '🍽',
    'Restaurant / Café',
    ['Denrées', 'Boissons', 'Loyer', 'Personnel', 'Divers'],
    ['pce', 'portion', 'forfait'],
  ],
  [
    'retail',
    '🛍',
    'Commerce de détail',
    ['Marchandises', 'Loyer', 'Marketing', 'Divers'],
    ['pce', 'lot', 'forfait'],
  ],
  [
    'services',
    '💻',
    'Informatique / Services',
    ['Sous-traitance', 'Logiciels', 'Matériel', 'Divers'],
    ['h', 'jour', 'forfait', 'pce'],
  ],
  [
    'transport',
    '🚚',
    'Transport / Livraison',
    ['Carburant', 'Véhicule', 'Sous-traitance', 'Divers'],
    ['km', 'h', 'forfait', 'pce'],
  ],
  [
    'autre',
    '📌',
    'Autre métier',
    ['Matériaux', 'Sous-traitance', 'Location', 'Divers'],
    ['pce', 'h', 'forfait', 'm²'],
  ],
];

export const metierCats = (soc, estMag) => {
  const mag = estMag !== undefined ? estMag : soc && soc.secteur === 'magasin';
  if (mag) {
    const a = soc && Array.isArray(soc.catsMag) && soc.catsMag.length ? soc.catsMag : null;
    return (
      a || [
        'Achats marchandises',
        'Fournisseurs',
        'Loyer',
        'Énergie',
        'Transport',
        'Salaires',
        'Entretien',
        'Divers',
      ]
    );
  }
  const a = soc && Array.isArray(soc.cats) && soc.cats.length ? soc.cats : null;
  return a || ['Matériaux', 'Sous-traitance', 'Location', 'Carburant', 'Divers'];
};

export const metierRayons = (soc, estMag) => {
  const mag = estMag !== undefined ? estMag : soc && soc.secteur === 'magasin';
  const k = mag ? 'rayonsMag' : 'rayonsBat';
  const a = soc && Array.isArray(soc[k]) ? soc[k] : null;
  return a || [];
};

/**
 * Unités proposées d'office, celles de la maquette V288 ; les Réglages les
 * remplacent par la liste de la société.
 */
const UNITES_MAG = [
  'pièce',
  'paire',
  'lot',
  'pack',
  'kit',
  'set',
  'boîte',
  'carton',
  'caisse',
  'sac',
  'sachet',
  'rouleau',
  'bobine',
  'palette',
  'bouteille',
  'bidon',
  'flacon',
  'pot',
  'tube',
  'seau',
  'plaque',
  'feuille',
  'barre',
  'profilé',
  'panneau',
  'mm',
  'cm',
  'm',
  'ml',
  'm²',
  'm³',
  'g',
  'kg',
  't',
  'cl',
  'L',
];
const UNITES_BAT = [
  'mm',
  'cm',
  'm',
  'ml',
  'm²',
  'm³',
  'g',
  'kg',
  't',
  'cl',
  'L',
  'h',
  'pièce',
  'forfait',
];

/**
 * La liste augmentée d'une valeur saisie, sauf si elle y figure déjà.
 *
 * <p>« Mon activité » ajoutait l'unité, la catégorie ou le corps de métier
 * tapé sans regarder la liste : « plaque » saisi deux fois donnait deux
 * pastilles « plaque », et React se plaignait de clés en double. La casse et
 * les espaces autour ne font pas une autre valeur.
 *
 * @param {string[]} liste valeurs déjà présentes
 * @param {string} valeur saisie de l'utilisateur
 * @returns {string[]} la liste, complétée ou identique
 */
export const avecSansDoublon = (liste, valeur) => {
  const v = String(valeur || '').trim();
  if (!v) return liste;
  const cle = v.toLocaleLowerCase('fr-CH');
  return liste.some((x) => String(x).trim().toLocaleLowerCase('fr-CH') === cle)
    ? liste
    : [...liste, v];
};

export const metierUnites = (soc, estMag) => {
  const mag = estMag !== undefined ? estMag : soc && soc.secteur === 'magasin';
  if (mag) {
    const a = soc && Array.isArray(soc.unitesMag) && soc.unitesMag.length ? soc.unitesMag : null;
    return a || UNITES_MAG;
  }
  const a = soc && Array.isArray(soc.unites) && soc.unites.length ? soc.unites : null;
  return a || UNITES_BAT;
};

export const vacAge = (dn) => {
  if (!dn) return null;
  const d = new Date(dn);
  if (isNaN(d.getTime())) return null;
  const a = Math.floor((Date.now() - d.getTime()) / (365.25 * 24 * 3600 * 1000));
  if (a < 0 || a > 120) return null;
  return a < 20 || a >= 50 ? 30 : 25;
};

export const CHAMPS = [
  ["Nom de l'entreprise", 'nom', 'Exemple Sàrl'],
  ['Adresse', 'adr', 'Rue du Marché 1'],
  ['NPA / Ville', 'npa', '1000 Lausanne'],
  ['Téléphone', 'tel', '+41 22 700 00 00'],
  ['E-mail', 'email', 'contact@exemple.ch'],
  ['IBAN (pour le QR-facture)', 'iban', 'CH93 0076 2011 6238 5295 7'],
  ['N° TVA', 'tva', 'CHE-123.456.789 TVA'],
];

export const BAT_PRESETS = [
  {
    metier: 'Carrelage / Faïence',
    arts: [
      { nom: 'Pose carrelage sol grand format', u: 'm²', p: 85 },
      { nom: 'Pose faïence murale salle de bain', u: 'm²', p: 95 },
      { nom: 'Réalisation chape de ravoirage', u: 'm²', p: 45 },
      { nom: 'Pose plinthes carrelage', u: 'ml', p: 22 },
      { nom: 'Joints époxy douche', u: 'forfait', p: 380 },
    ],
  },
  {
    metier: 'Peinture',
    arts: [
      { nom: 'Mise en peinture murs 2 couches', u: 'm²', p: 18 },
      { nom: 'Application sous-couche', u: 'm²', p: 8 },
      { nom: 'Peinture plafond', u: 'm²', p: 16 },
      { nom: 'Laquage boiseries', u: 'ml', p: 28 },
      { nom: 'Enduit de lissage mural', u: 'm²', p: 22 },
    ],
  },
  {
    metier: 'Plâtrerie / Cloisons',
    arts: [
      { nom: 'Montage cloison placo BA13', u: 'm²', p: 55 },
      { nom: 'Pose faux-plafond suspendu', u: 'm²', p: 65 },
      { nom: 'Bande à joint et lissage', u: 'm²', p: 14 },
      { nom: 'Doublage isolant mur', u: 'm²', p: 48 },
      { nom: 'Habillage gaine technique', u: 'forfait', p: 420 },
    ],
  },
  {
    metier: 'Maçonnerie',
    arts: [
      { nom: 'Coulage chape ciment', u: 'm²', p: 42 },
      { nom: 'Montage mur parpaing', u: 'm²', p: 75 },
      { nom: 'Réalisation crépi extérieur', u: 'm²', p: 55 },
      { nom: 'Ragréage sol', u: 'm²', p: 28 },
      { nom: 'Scellement et reprise maçonnée', u: 'forfait', p: 480 },
    ],
  },
  {
    metier: 'Plomberie / Sanitaire',
    arts: [
      { nom: 'Pose WC suspendu complet', u: 'forfait', p: 680 },
      { nom: 'Installation lavabo + mitigeur', u: 'forfait', p: 420 },
      { nom: 'Remplacement colonne de douche', u: 'forfait', p: 350 },
      { nom: 'Raccordement évier cuisine', u: 'forfait', p: 280 },
      { nom: 'Recherche et réparation fuite', u: 'h', p: 110 },
    ],
  },
  {
    metier: 'Chauffage',
    arts: [
      { nom: 'Pose radiateur acier', u: 'forfait', p: 380 },
      { nom: 'Mise en service plancher chauffant', u: 'forfait', p: 650 },
      { nom: 'Installation thermostat connecté', u: 'forfait', p: 240 },
      { nom: 'Désembouage circuit chauffage', u: 'forfait', p: 520 },
      { nom: 'Entretien chaudière', u: 'forfait', p: 180 },
    ],
  },
  {
    metier: 'Ventilation / Clim.',
    arts: [
      { nom: 'Installation VMC simple flux', u: 'forfait', p: 780 },
      { nom: 'Pose split climatisation', u: 'forfait', p: 1200 },
      { nom: 'Nettoyage réseau de gaines', u: 'forfait', p: 420 },
      { nom: 'Remplacement extracteur SDB', u: 'forfait', p: 260 },
      { nom: 'Mise en service VMC double flux', u: 'forfait', p: 950 },
    ],
  },
  {
    metier: 'Électricité',
    arts: [
      { nom: 'Pose tableau électrique', u: 'forfait', p: 890 },
      { nom: 'Création point lumineux', u: 'pce', p: 120 },
      { nom: 'Pose prise / interrupteur', u: 'pce', p: 65 },
      { nom: 'Mise aux normes installation', u: 'forfait', p: 1400 },
      { nom: 'Câblage réseau / domotique', u: 'h', p: 105 },
    ],
  },
  {
    metier: 'Menuiserie / Agencement',
    arts: [
      { nom: 'Pose bloc-porte intérieur', u: 'forfait', p: 420 },
      { nom: 'Fabrication placard sur mesure', u: 'm²', p: 320 },
      { nom: 'Pose plinthes bois', u: 'ml', p: 24 },
      { nom: 'Agencement dressing', u: 'forfait', p: 1800 },
      { nom: 'Réglage quincaillerie portes', u: 'h', p: 95 },
    ],
  },
  {
    metier: 'Couverture / Toiture',
    arts: [
      { nom: 'Réfection couverture tuiles', u: 'm²', p: 95 },
      { nom: 'Pose zinguerie / chéneau', u: 'ml', p: 55 },
      { nom: 'Remplacement faîtage', u: 'ml', p: 48 },
      { nom: 'Traitement hydrofuge toiture', u: 'm²', p: 18 },
      { nom: 'Réparation fuite toiture', u: 'forfait', p: 480 },
    ],
  },
  {
    metier: 'Étanchéité',
    arts: [
      { nom: 'Étanchéité toiture terrasse', u: 'm²', p: 75 },
      { nom: 'Pose membrane bitume', u: 'm²', p: 45 },
      { nom: 'Étanchéité douche italienne', u: 'forfait', p: 520 },
      { nom: 'Traitement fissures façade', u: 'ml', p: 35 },
      { nom: 'Étanchéité balcon', u: 'm²', p: 68 },
    ],
  },
  {
    metier: 'Fenêtres',
    arts: [
      { nom: 'Pose fenêtre PVC double vitrage', u: 'forfait', p: 680 },
      { nom: 'Pose volet roulant', u: 'forfait', p: 420 },
      { nom: 'Remplacement vitrage isolant', u: 'forfait', p: 350 },
      { nom: 'Pose store extérieur', u: 'forfait', p: 560 },
      { nom: 'Réglage et calfeutrage', u: 'h', p: 90 },
    ],
  },
  {
    metier: 'Vitrerie',
    arts: [
      { nom: 'Remplacement verre cassé', u: 'forfait', p: 220 },
      { nom: 'Pose miroir sur mesure', u: 'm²', p: 180 },
      { nom: 'Pose paroi de douche verre', u: 'forfait', p: 680 },
      { nom: 'Pose crédence verre cuisine', u: 'm²', p: 240 },
      { nom: 'Dépose et repose vitrage', u: 'h', p: 95 },
    ],
  },
  {
    metier: 'Serrurerie / Métallerie',
    arts: [
      { nom: 'Pose garde-corps acier', u: 'ml', p: 180 },
      { nom: 'Fabrication portail métal', u: 'forfait', p: 2200 },
      { nom: 'Pose rampe escalier', u: 'ml', p: 150 },
      { nom: 'Remplacement serrure', u: 'forfait', p: 180 },
      { nom: 'Soudure et reprise métallerie', u: 'h', p: 110 },
    ],
  },
  {
    metier: 'Sols / Parquet',
    arts: [
      { nom: 'Pose parquet contrecollé', u: 'm²', p: 55 },
      { nom: 'Pose sol PVC / vinyle', u: 'm²', p: 38 },
      { nom: 'Pose stratifié clipsable', u: 'm²', p: 32 },
      { nom: 'Ponçage et vitrification parquet', u: 'm²', p: 42 },
      { nom: 'Pose plinthes assorties', u: 'ml', p: 18 },
    ],
  },
  {
    metier: 'Nettoyage / Fin de chantier',
    arts: [
      { nom: 'Nettoyage fin de chantier', u: 'm²', p: 6 },
      { nom: 'Débarras et évacuation gravats', u: 'forfait', p: 380 },
      { nom: 'Nettoyage vitres', u: 'm²', p: 5 },
      { nom: 'Décapage et remise en état sols', u: 'm²', p: 9 },
      { nom: 'Protection chantier', u: 'forfait', p: 180 },
    ],
  },
];

export const TRADE_PRESETS = [
  {
    metier: 'Carrelage',
    arts: [
      { nom: 'Grès cérame 60×60', cat: 'Carrelage', u: 'm²', pv: 95 },
      { nom: 'Mosaïque 25×25', cat: 'Carrelage', u: 'm²', pv: 140 },
      { nom: 'Colle C2TE', cat: 'Colles', u: 'sac', pv: 24.5 },
      { nom: 'Joint époxy', cat: 'Colles', u: 'kg', pv: 19 },
    ],
  },
  {
    metier: 'Plâtrerie / Placo',
    arts: [
      { nom: 'Plaque BA13', cat: 'Placo', u: 'm²', pv: 14 },
      { nom: 'Rail R48', cat: 'Placo', u: 'ml', pv: 3.2 },
      { nom: 'Montant M48', cat: 'Placo', u: 'ml', pv: 3.5 },
      { nom: 'Enduit de lissage', cat: 'Placo', u: 'sac', pv: 18 },
    ],
  },
  {
    metier: 'Chauffage / Sanitaire',
    arts: [
      { nom: 'Tube chauffage au sol PER', cat: 'Chauffage', u: 'ml', pv: 4.8 },
      { nom: 'Radiateur acier 600×1000', cat: 'Chauffage', u: 'pce', pv: 240 },
      { nom: 'Collecteur', cat: 'Chauffage', u: 'pce', pv: 180 },
    ],
  },
  {
    metier: 'Électricité',
    arts: [
      { nom: 'Câble 3G1.5', cat: 'Électricité', u: 'ml', pv: 1.8 },
      { nom: 'Prise', cat: 'Électricité', u: 'pce', pv: 8 },
      { nom: 'Interrupteur', cat: 'Électricité', u: 'pce', pv: 9 },
    ],
  },
  {
    metier: 'Peinture',
    arts: [
      { nom: 'Peinture blanche mate', cat: 'Peinture', u: 'L', pv: 21 },
      { nom: 'Sous-couche', cat: 'Peinture', u: 'L', pv: 14 },
      { nom: 'Rouleau', cat: 'Peinture', u: 'pce', pv: 9 },
    ],
  },
  {
    metier: 'Menuiserie',
    arts: [
      { nom: 'Plinthe MDF', cat: 'Menuiserie', u: 'ml', pv: 6.5 },
      { nom: 'Porte intérieure', cat: 'Menuiserie', u: 'pce', pv: 420 },
    ],
  },
  {
    metier: 'Maçonnerie',
    arts: [
      { nom: 'Ciment Portland 25kg', cat: 'Béton', u: 'sac', pv: 14.5 },
      { nom: 'Brique', cat: 'Béton', u: 'pce', pv: 1.2 },
      { nom: 'Mortier', cat: 'Béton', u: 'sac', pv: 12 },
    ],
  },
  {
    metier: 'Étanchéité / Toiture',
    arts: [
      { nom: 'Membrane EPDM', cat: 'Étanch.', u: 'm²', pv: 28 },
      { nom: 'Tuile', cat: 'Toiture', u: 'pce', pv: 2.1 },
    ],
  },
  {
    metier: 'Isolation',
    arts: [
      { nom: 'Laine de verre', cat: 'Isolation', u: 'm²', pv: 9 },
      { nom: 'Panneau PIR', cat: 'Isolation', u: 'm²', pv: 22 },
    ],
  },
];
